import { render, staticRenderFns } from "./ManageService.vue?vue&type=template&id=1b4ff0d3&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./ManageService.vue?vue&type=style&index=0&id=1b4ff0d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4ff0d3",
  null
  
)

export default component.exports